import { render } from "./ShinaiLoading.vue?vue&type=template&id=390e457b&scoped=true"
import script from "./ShinaiLoading.vue?vue&type=script&lang=js"
export * from "./ShinaiLoading.vue?vue&type=script&lang=js"

import "./ShinaiLoading.vue?vue&type=style&index=0&id=390e457b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/shinai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390e457b"]])

export default __exports__